module.exports = __webpack_public_path__ + "img/0Q3A3494_FoamcoreMatted.e7ff07e5.jpg";